import { isNil } from 'lodash';

/**
 * Utils for any string-related issues
 */
class StringUtils {
  /**
   * Detects if any of given values are included in source string
   * @param source - String to look inside
   * @param values - array of values
   * @return boolean - found any occurance
   */
  includesMultipleStrings = (source, values) => {
    if (isNil(values) || isNil(source)) {
      return false;
    }
    // map() here is only for functional approach. Actually we don't need new arra
    const regExp = new RegExp(values.map((value) => value.toLowerCase()).join('|'));

    return regExp.test(source.toLowerCase());
  };

  /**
   * Detects if there anything else inside of incoming string but "<tags>"
   * @param source - Source string
   */
  isNilOrEmptyWithoutHtmlTags = (source) => source === null || source === undefined || (source.toString().replace(/<[^>]*>/g, '').length === 0);

  /**
   * Get decimal's delimiter for current browser locale
   */
  getDelimiterForCurrentLocale = () => {
    const numberWithDecimalSeparator = 1.1;

    return (navigator && Intl.NumberFormat(navigator.language).format(numberWithDecimalSeparator).substring(1, 2)) || '.';
  };

  /**
   * Check if the provided string is the stringified json object
   * @param str - String to check
   * @return boolean
   */
  isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }

    return true;
  };
}

export default new StringUtils();
